export default {
  $el: 'section',
  attrs: {},
  children: [
    {
      label: 'Successful ransomware attack?',
      $formkit: 'radio',
      if: '$incidentForms.type === Security',
      name: 'securityRansomware',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Critical infrastructure disruptions?',
      $formkit: 'radio',
      if: '$incidentForms.securityRansomware === no',
      name: 'securityInfrastructureDisruptions',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Data breach affecting large volumes of information?',
      $formkit: 'radio',
      if: '$incidentForms.securityInfrastructureDisruptions === no',
      name: 'securityDataBreach',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Significant data breach or large scale malware outbreak?',
      $formkit: 'radio',
      if: '$incidentForms.securityDataBreach === no',
      name: 'securityMalwareOutbreak',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Malware infection?',
      $formkit: 'radio',
      if: '$incidentForms.securityMalwareOutbreak === no',
      name: 'securityMalwareInfection',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Successful phishing attack?',
      $formkit: 'radio',
      if: '$incidentForms.securityMalwareInfection === no',
      name: 'securityPhishingAttack',
      help: 'Compromised sensitive data or unauthorised access to system',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Unauthorised access to systems or data?',
      $formkit: 'radio',
      if: '$incidentForms.securityPhishingAttack === no',
      name: 'securityUnauthorisedAccess',
      help: 'By employees or external parties',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Denial of Service attack?',
      $formkit: 'radio',
      if: '$incidentForms.securityUnauthorisedAccess === no',
      name: 'securityDenialOfServiceAttack',
      help: 'By employees or external parties',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label:
        'Employees or contractors intentionally or unintentionally compromised security?',
      $formkit: 'radio',
      if: '$incidentForms.securityDenialOfServiceAttack === no',
      name: 'securityCompromisedSecurity',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      label: 'Lost or stolen asset?',
      $formkit: 'radio',
      if: '$incidentForms.securityCompromisedSecurity === no',
      name: 'securityLostOrStolenAsset',
      optionsClass: 'inline',
      options: [
        {
          label: 'Yes',
          value: 'yes',
        },
        {
          label: 'No',
          value: 'no',
        },
      ],
    },
    {
      $el: 'div',
      if: '$incidentForms.securityLostOrStolenAsset === no',
      children: [
        {
          $el: 'section',
          attrs: {
            class: 'incident-details',
          },
          children: [
            {
              $el: 'h3',
              children: "We don't believe this is an incident",
            },
            {
              $el: 'p',
              children: ['Please contact the security team for help.'],
            },
          ],
        },
      ],
    },
  ],
}
